import script from "./EnrichmentSuccessBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrichmentSuccessBanner.vue?vue&type=script&setup=true&lang=js"

import "./EnrichmentSuccessBanner.vue?vue&type=style&index=0&id=d73c79d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d73c79d6"]])

export default __exports__